import { render, staticRenderFns } from "./properties-block-navigation.vue?vue&type=template&id=4b2212e5&scoped=true"
import script from "./properties-block-navigation.vue?vue&type=script&lang=js"
export * from "./properties-block-navigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2212e5",
  null
  
)

export default component.exports